import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styles from './styles';

export default class ResponsiveTable extends PureComponent {
  static propTypes = {
    columns: PropTypes.objectOf(PropTypes.shape({
      bold: PropTypes.bool,
      filter: PropTypes.func,
      grow: PropTypes.bool,
      heading: PropTypes.node.isRequired,
      width: PropTypes.string
    })).isRequired,
    rows: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.node)).isRequired,
    type: PropTypes.oneOf(['rounded', 'default', 'default-static'])
  };
  static defaultProps = {
    type: 'default'
  };

  renderHeaderCell(columnName, { grow, heading, width }) {
    const classes = [styles.responsiveTableCell, styles.responsiveTableHeader];

    if (grow) {
      classes.push(styles.responsiveTableCellGrow);
    }

    return (
      <div
        key={ `heading-${columnName}` }
        className={ classes.join(' ') }
        style={{
          flexBasis: width || '100px'
        }}
      >
        { heading }
      </div>
    );
  }

  renderContentCell(columnName, content) {

    // This is an extra cell, we can ignore it
    if (!this.props.columns[columnName]) {
      return null;
    }

    const classes = [styles.responsiveTableCell];
    const { bold, filter, grow, heading, width } = this.props.columns[columnName];
    let title;

    if (grow) {
      classes.push(styles.responsiveTableCellGrow);
    }

    if (bold) {
      classes.push(styles.responsiveTableCellBold);
    }

    // Optionally apply a filter to the content to mutate the value
    if (filter) {
      title = content;
      content = filter(content);
    }

    return (
      <div
        key={ `content-${columnName}` }
        className={ classes.join(' ') }
        data-heading={ heading }
        title={ title }
        style={{
          flexBasis: width || '100px'
        }}
      >
        <div className={ styles.responsiveTableCellContent }>
          { content }
        </div>
      </div>
    );
  }

  renderHeader(columns) {
    const classes = [styles.responsiveTableRow, styles.responsiveTableRowHeader];

    return (
      <div key="heading-row" className={ classes.join(' ') }>
        { Object.keys(columns).map((columnName) => this.renderHeaderCell(columnName, columns[columnName])) }
      </div>
    );
  }

  renderRow(row, idx) {
    return (
      <div key={ `content-row-${idx}` } className={ styles.responsiveTableRow }>
        { Object.keys(row).map((columnName) => this.renderContentCell(columnName, row[columnName])) }
      </div>
    )
  }

  render() {
    const { columns, rows, type } = this.props;
    const classes = [styles.responsiveTable];

    switch (type) {
      case 'rounded':
        classes.push(styles.responsiveTableRounded, styles.responsiveTableMobileFriendly);
        break;
      case 'default-static':
        classes.push(styles.responsiveTableDefault);
        break;
      default:
        classes.push(styles.responsiveTableDefault, styles.responsiveTableMobileFriendly);
    }

    return (
      <div className={ classes.join(' ') }>
        { this.renderHeader(columns) }
        { rows.map((row, idx) => this.renderRow(row, idx)) }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ResponsiveTable/index.jsx